// Unpublished Work © 2026 Deere & Company.

import * as actions from '../../action-list';
import {Criteria} from '../../state/struct/digital-user-search/facets/criteria';
import {DigitalUserSearch} from '../../state/struct/digital-user-search/digital-user-search';

const updateCriteriaField = (state, action) => Criteria.update(state, {
    [action.key]: {
        $set: action.value
    }
});

const updateMultipleCriteria = (state, action) => Criteria.update(state, {
    $merge: action.criteria
});

const resetCriteria = (state, action) => new Criteria({
    resetKey: state.resetKey + 1,
    selectedCountry: action.initialCountry
});

export const criteria = (state = new DigitalUserSearch({}).criteria, action = {}) => {
    const actionHandlers = {
        [actions.SET_DIGITAL_USER_SEARCH_CRITERIA]: updateCriteriaField,
        [actions.SET_DIGITAL_USER_SEARCH_CRITERIA_MULTIPLE]: updateMultipleCriteria,
        [actions.RESET_DIGITAL_USER_SEARCH]: resetCriteria
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
